import React from 'react'
import { SvgImage } from 'components/SvgImage'
import starSvg from 'assets/images/sprite/star.svg'
import { ISvg } from 'components/SvgImage/SvgImage'
import { StyledCustomerReviews as S } from './Review.styles'

type TReviewProps = {
  author: string
  text: string
  className?: string
  icon?: ISvg
}
export const Review: React.FC<TReviewProps> = ({
  author,
  text,
  className = '',
  icon,
}) => {
  return (
    <S.ReviewContainer className={className}>
      <S.Author>{author}</S.Author>
      <S.Rating>
        <SvgImage svg={starSvg} />
        <SvgImage svg={starSvg} />
        <SvgImage svg={starSvg} />
        <SvgImage svg={starSvg} />
        <SvgImage svg={starSvg} />
      </S.Rating>
      <S.Text>
        {text}
        {icon && <SvgImage svg={icon} height={18} />}
      </S.Text>
    </S.ReviewContainer>
  )
}
